// Older merchants may have no business name yet, and their handle is what they are known by.
export const merchantName = merchant => merchant?.attributes.user_name || merchant?.attributes.handle || ''

// "City, ST" for a franchisee, or empty when neither is set.
export const merchantLocation = merchant =>
  [merchant?.attributes.city, merchant?.attributes.state].filter(Boolean).join(', ')

// The franchise menu (blueprint) id as a string, from the stored record or the franchise, or null without one.
export const blueprintIdOf = state => {
  const id = state?.franchiseBlueprint?.id ?? state?.franchise?.attributes?.blueprint_user_id
  return id === null || id === undefined ? null : String(id)
}

export const isBlueprintId = (id, blueprintId) =>
  !!id && blueprintId !== null && blueprintId !== undefined && String(id) === String(blueprintId)

// The location the reports and the calendar scope to. The franchise menu is not a location that sells,
// so while it is active they read as all locations.
export const reportingMerchantId = state => {
  const id = state.activeFranchiseMerchantId || null
  return isBlueprintId(id, blueprintIdOf(state)) ? null : id
}
